import { render, staticRenderFns } from "./AddToBasket.vue?vue&type=template&id=fde5edaa&scoped=true&"
import script from "./AddToBasket.vue?vue&type=script&lang=js&"
export * from "./AddToBasket.vue?vue&type=script&lang=js&"
import style0 from "./AddToBasket.vue?vue&type=style&index=0&id=fde5edaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fde5edaa",
  null
  
)

component.options.__file = "AddToBasket.vue"
export default component.exports